import { createFileRoute, Outlet } from "@tanstack/react-router";
import queryClient from "api/queryClient.ts";
import { composeGetOfferQueryOptions } from "api/TenantSlug/Offer/queryOptions.ts";
import { QueryState } from "components/UI/QueryState/QueryState.tsx";

export const Route = createFileRoute("/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout")({
    loader: async ({ params: { offerId } }) => {
        let breadcrumb = offerId;

        try {
            const { offer } = await queryClient.ensureQueryData(composeGetOfferQueryOptions(offerId, {}));

            breadcrumb = offer.visible_title;
        } catch (e) {
            console.error(e);
        }

        return {
            breadcrumb,
            asActive: true,
        };
    },
    pendingComponent: () => <QueryState isLoading={true} isError={false} />,
    errorComponent: () => <QueryState isLoading={false} isError={true} errorKey="errors.loading_offer" />,
    component: () => <Outlet />,
});
